module.exports = __webpack_public_path__ + "static/media/plant2.8b813eb3.jpg";